import { authApi } from './authApi';

export const fetchProjects = async (params?: any): Promise<any> => {
  return await authApi.get(
    `umbrella/projects/?parent_name=true&type=all${params ? params : ''}`
  );
};

export const fetchProductMaster = async (): Promise<any> => {
  return await authApi.get('admin/product_master/?type=all');
};

export const fetchProjectTable = async (params: string): Promise<any> => {
  return await authApi.get(
    `umbrella/projects/${params}&parent_name=true&ordering=-created_on`
  );
};

export const editProjectData = async (payload: any) => {
  return await authApi.patch(
    `umbrella/projects/${payload?.id}/`,
    payload?.body
  );
};

export const addProject = async (payload: any) => {
  return await authApi.post('umbrella/projects/', payload);
};

export const deleteProject = async (payload: any): Promise<any> => {
  return await authApi.delete('umbrella/projects/', { data: payload });
};

export const labelCreation = async (payload: any) => {
  return await authApi.post('umbrella/project_label/', payload);
};

export const editProjectLabel = async (payload: any) => {
  return await authApi.patch(
    `umbrella/project_label/${payload?.id}/`,
    payload?.body
  );
};

export const fetchLabel = async (): Promise<any> => {
  return await authApi.get('umbrella/project_label/');
};
